module.exports = __webpack_public_path__ + "static/media/paragraph.42054b9e.svg";